import {
  ICON_KEYS,
  type HardcodedVariableIcon,
  type IconKey,
} from "./digital-cards.interface";

const ICON_FILE_BY_KEY: Record<IconKey, string> = {
  phone: "phone",
  mobile: "mobile",
  email: "email",
  www: "www",
  calendar: "calendar",
  behance: "behance",
  coffee: "coffee",
  facebook: "facebook",
  github: "github",
  gitlab: "gitlab",
  gitter: "gitter",
  heart: "heart",
  instagram: "instagram",
  linkedin: "linkedin",
  mastodon: "mastodon",
  menu: "menu",
  ok: "ok",
  reddit: "reddit",
  skype: "skype",
  slack: "slack",
  stackoverflow: "stackoverflow",
  telegram: "telegram",
  vk: "vk",
  whatsapp: "whatsapp",
  x: "x",
  xing: "xing",
  youtube: "youtube",
  manager: "manager",
  jobTitle: "job-title",
  department: "department",
  branchName: "branch-name",
  branchAddress: "branch-address",
  workAddress: "work-address",
  customLink: "custom-link",
};

const ICON_LABEL_BY_KEY: Record<IconKey, string> = {
  phone: "Phone",
  mobile: "Mobile",
  email: "Email",
  www: "Website",
  calendar: "Calendar",
  behance: "Behance",
  coffee: "Coffee",
  facebook: "Facebook",
  github: "GitHub",
  gitlab: "GitLab",
  gitter: "Gitter",
  heart: "Heart",
  instagram: "Instagram",
  linkedin: "LinkedIn",
  mastodon: "Mastodon",
  menu: "Menu",
  ok: "OK",
  reddit: "Reddit",
  skype: "Skype",
  slack: "Slack",
  stackoverflow: "Stack Overflow",
  telegram: "Telegram",
  vk: "VK",
  whatsapp: "WhatsApp",
  x: "X",
  xing: "Xing",
  youtube: "YouTube",
  manager: "Manager",
  jobTitle: "Job title",
  department: "Department",
  branchName: "Branch name",
  branchAddress: "Branch address",
  workAddress: "Work address",
  customLink: "Custom link",
};

export const HARDCODED_VARIABLE_ICONS: HardcodedVariableIcon[] = ICON_KEYS.map(
  (key) => {
    const file = ICON_FILE_BY_KEY[key];
    return {
      key,
      label: ICON_LABEL_BY_KEY[key],
      value: `/icons/variables/${file}.svg`,
      preview: `assets/icons/variables/${file}.svg`,
    };
  },
);

const HARDCODED_BY_VALUE = new Map(
  HARDCODED_VARIABLE_ICONS.map((icon) => [icon.value, icon]),
);

const HARDCODED_BY_KEY = new Map(
  HARDCODED_VARIABLE_ICONS.map((icon) => [icon.key, icon]),
);

const ICON_BY_COMPACT = new Map<string, IconKey>(
  ICON_KEYS.map((key) => [key.toLowerCase(), key]),
);

const VARIABLE_NAME_ALIASES: Record<string, IconKey> = {
  phonenumber: "phone",
  workphone: "phone",
  officephone: "phone",
  mobilenumber: "mobile",
  cellphone: "mobile",
  cellnumber: "mobile",
  emailaddress: "email",
  mail: "email",
  website: "www",
  webpage: "www",
  homepage: "www",
  companywebsite: "www",
  url: "www",
  calendarlink: "calendar",
  bookingurl: "calendar",
  meetinglink: "calendar",
  meetingurl: "calendar",
  calendly: "calendar",
  calendlylink: "calendar",
  calendlyurl: "calendar",
  cal: "calendar",
  calcom: "calendar",
  caldotcom: "calendar",
  scheduling: "calendar",
  schedulinglink: "calendar",
  appointment: "calendar",
  appointmentlink: "calendar",
  linkedinlink: "linkedin",
  linkedinurl: "linkedin",
  personlinkedinurl: "linkedin",
  linkedincompany: "linkedin",
  linkedinprofile: "linkedin",
  facebookcompany: "facebook",
  facebookurl: "facebook",
  facebookpage: "facebook",
  facebooklink: "facebook",
  twitter: "x",
  twitterlink: "x",
  xcompany: "x",
  twitterurl: "x",
  twittercompany: "x",
  whatsappnumber: "whatsapp",
  whatsappurl: "whatsapp",
  whatsapplink: "whatsapp",
  instagramcompany: "instagram",
  instagramurl: "instagram",
  instagramlink: "instagram",
  youtubechannel: "youtube",
  youtubeurl: "youtube",
  youtubelink: "youtube",
  githubprofile: "github",
  githubcompany: "github",
  githublink: "github",
  gitlaburl: "gitlab",
  redditurl: "reddit",
  telegramurl: "telegram",
  telegramusername: "telegram",
  skypeid: "skype",
  skypeurl: "skype",
  skypelink: "skype",
  slackurl: "slack",
  slacklink: "slack",
  stackoverflowurl: "stackoverflow",
  xinglink: "xing",
  xingurl: "xing",
  vkurl: "vk",
  mastodonurl: "mastodon",
  behanceurl: "behance",
  behancelink: "behance",
  job: "jobTitle",
  jobtitle: "jobTitle",
  position: "jobTitle",
  role: "jobTitle",
  usermanager: "manager",
  supervisor: "manager",
  username: "manager",
  fullname: "manager",
  name: "manager",
  firstname: "manager",
  lastname: "manager",
  givenname: "manager",
  familyname: "manager",
  displayname: "manager",
  personname: "manager",
  employeename: "manager",
  userdepartment: "department",
  team: "department",
  userbranchname: "branchName",
  branch: "branchName",
  branchname: "branchName",
  userbranchaddress: "branchAddress",
  branchaddress: "branchAddress",
  branchcity: "branchAddress",
  branchpostalcode: "branchAddress",
  branchcountry: "branchAddress",
  userbranchmail: "email",
  branchemail: "email",
  branchmail: "email",
  userbranchphone: "phone",
  branchphone: "phone",
  userworkaddress: "workAddress",
  workaddress: "workAddress",
  officeaddress: "workAddress",
  address: "workAddress",
  usercustomlink: "customLink",
  customlink: "customLink",
  userabout: "heart",
  about: "heart",
  bio: "heart",
  messenger: "customLink",
  messengerlink: "customLink",
  messengerurl: "customLink",
  tiktok: "customLink",
  tiktoklink: "customLink",
  tiktokurl: "customLink",
  dribbble: "customLink",
  dribbblelink: "customLink",
  dribbbleurl: "customLink",
  goodreads: "customLink",
  goodreadslink: "customLink",
  medium: "customLink",
  mediumlink: "customLink",
  pinterest: "customLink",
  pinterestlink: "customLink",
  snapchat: "customLink",
  snapchatlink: "customLink",
  strava: "customLink",
  stravalink: "customLink",
  viber: "customLink",
  viberlink: "customLink",
};

const STRIPPABLE_SUFFIXES = [
  "company",
  "channel",
  "profile",
  "account",
  "address",
  "number",
  "page",
  "url",
  "link",
  "id",
];

const CONTACT_ICON_KEYS = new Set<IconKey>([
  "phone",
  "mobile",
  "email",
  "www",
  "calendar",
  "behance",
  "facebook",
  "github",
  "gitlab",
  "gitter",
  "instagram",
  "linkedin",
  "mastodon",
  "reddit",
  "skype",
  "slack",
  "stackoverflow",
  "telegram",
  "vk",
  "whatsapp",
  "x",
  "xing",
  "youtube",
]);

export function iconKeyForVariable(name: string): IconKey | null {
  const compact = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
  if (!compact) {
    return null;
  }
  if (VARIABLE_NAME_ALIASES[compact]) {
    return VARIABLE_NAME_ALIASES[compact];
  }
  if (ICON_BY_COMPACT.has(compact)) {
    return ICON_BY_COMPACT.get(compact) ?? null;
  }
  for (const suffix of STRIPPABLE_SUFFIXES) {
    if (!compact.endsWith(suffix) || compact.length <= suffix.length) {
      continue;
    }
    const stripped = compact.slice(0, -suffix.length);
    if (VARIABLE_NAME_ALIASES[stripped]) {
      return VARIABLE_NAME_ALIASES[stripped];
    }
    if (ICON_BY_COMPACT.has(stripped)) {
      return ICON_BY_COMPACT.get(stripped) ?? null;
    }
  }
  return null;
}

export function variableHasContactIcon(name: string): boolean {
  const key = iconKeyForVariable(name);
  return key !== null && CONTACT_ICON_KEYS.has(key);
}

export function hardcodedIconByKey(key: IconKey): HardcodedVariableIcon {
  const icon = HARDCODED_BY_KEY.get(key);
  if (!icon) {
    throw new Error(`Missing hardcoded variable icon: ${key}`);
  }
  return icon;
}

export function hardcodedIconForVariable(name: string): HardcodedVariableIcon {
  const key = iconKeyForVariable(name) ?? "customLink";
  return HARDCODED_BY_KEY.get(key) ?? hardcodedIconByKey("customLink");
}

export function hardcodedIconByValue(
  value: string | null | undefined,
): HardcodedVariableIcon | undefined {
  if (!value?.trim()) {
    return undefined;
  }
  return HARDCODED_BY_VALUE.get(value.trim());
}
